import { render, staticRenderFns } from "./icon-percent-sign.vue?vue&type=template&id=b4623000&"
import script from "./icon-percent-sign.vue?vue&type=script&lang=js&"
export * from "./icon-percent-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports